import { render, staticRenderFns } from "./contract-agentnew.vue?vue&type=template&id=c88b229e&scoped=true"
import script from "./contract-agentnew.vue?vue&type=script&lang=js"
export * from "./contract-agentnew.vue?vue&type=script&lang=js"
import style0 from "./contract-agentnew.vue?vue&type=style&index=0&id=c88b229e&prod&lang=css"
import style1 from "./contract-agentnew.vue?vue&type=style&index=1&id=c88b229e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88b229e",
  null
  
)

export default component.exports